type SVGProps = {
    color?: string;
    rotation?: number;
    translate?: number;
};

const LastPageIcon = (props: SVGProps) => {
    return (
        <svg
            width="13"
            height="15"
            viewBox="0 0 13 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={`rotate(${props.rotation ?? 0}) translate(${props.translate ?? 0})`}
        >
            <path
                d="M1.32104 1.23682L5.60188 7.16314L1.32104 13.0895"
                stroke={props.color ? props.color : "#FCFEFE"}
                strokeWidth="1.9981"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.59338 1.23682L11.8742 7.16314L7.59338 13.0895"
                stroke={props.color ? props.color : "#FCFEFE"}
                strokeWidth="1.9981"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const NextPageIcon = (props: SVGProps) => {
    return (
        <svg
            width="7"
            height="15"
            viewBox="0 0 7 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            transform={`rotate(${props.rotation ?? 0}) translate(${props.translate ?? 0})`}
        >
            <path
                d="M1.51013 1.57361L5.79097 7.49993L1.51013 13.4263"
                stroke={props.color ? props.color : "#FCFEFE"}
                strokeWidth="1.9981"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export { LastPageIcon, NextPageIcon };
